angular.module("users")

    .controller("UsersImportCtrl", ['$scope', '$rootScope', '$state', '$stateParams', 'Restangular', '$filter',
        function ($scope, $rootScope, $state, $stateParams, Restangular, $filter) {

            $rootScope.title = $filter('translate')('users.import');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('users.list'), url: "users.list" },
                { title: $filter('translate')('users.import') }
            ];

            // The preview rows travel in memory through the state params: a page reload loses them.
            $scope.rows = $stateParams.rows || [];
            if (!$scope.rows.length) {
                $state.go('users.list');
                return;
            }

            $scope.requireAuthenticator = false;
            $scope.importing = false;
            $scope.licenseWarning = null;

            $scope.importableCount = function () {
                return $scope.rows.filter(function (row) {
                    return !row.AlreadyExists && (!row.Errors || !row.Errors.length);
                }).length;
            };

            // Informative only: the licence limit is not enforced anywhere, and a failure here must never block the import.
            Restangular.all('Companies/' + $rootScope.company_id + '/Licenses').getList().then(function (licenses) {
                const lite = (licenses || []).find(function (license) { return license.name === 'lite'; });
                if (!lite || !lite.max) {
                    return;
                }
                // The parser lowercases Type only on rows with a valid type, so valid rows carry 'lite'.
                const liteToImport = $scope.rows.filter(function (row) {
                    return row.Type === 'lite' && !row.AlreadyExists && (!row.Errors || !row.Errors.length);
                }).length;
                if (liteToImport && lite.current + liteToImport > lite.max) {
                    $scope.licenseWarning = $filter('translate')('users.import_license_warning', {
                        count: liteToImport, current: lite.current, max: lite.max
                    });
                }
            }, function () { });

            $scope.doImport = function () {
                $scope.importing = true;
                // The rows go back as previewed, but the server trusts none of it: it ignores their errors, flags and resolved ids
                // and validates them again from scratch, resolving position, group and roles by name.
                Restangular.all('Users/Import').post({
                    users: $scope.rows,
                    require_authenticator: $scope.requireAuthenticator
                }).then(function (result) {
                    $scope.importing = false;
                    toastr.success($filter('translate')('users.import_done', { count: result && result.imported }));
                    $state.go('users.list', {}, { reload: true });
                }, function (error) {
                    $scope.importing = false;
                    toastr.error((error && error.data && error.data.Message) || $filter('translate')('users.import_error'));
                });
            };

            $scope.cancel = function () {
                $state.go('users.list');
            };

            $scope.downloadTemplate = function () {
                const header = 'nombre;apellidos;dni;correo;cargo;grupo;tipo;roles';
                // cargo must be the name of an existing position of the company; grupo and roles are optional.
                const example = 'Ana;García Ruiz;12345678Z;ana.garcia@ejemplo.com;Jefe de protocolo;;staff;';
                // BOM so that Excel respects the accents when opening the CSV.
                const blob = new Blob(["\uFEFF" + header + "\r\n" + example + "\r\n"], { type: 'text/csv;charset=utf-8;' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = 'plantilla_usuarios.csv';
                link.click();
                URL.revokeObjectURL(url);
            };
        }]);
